<template>
  <FlexColumn class="mb-8" :space="4">
    <ApplicantCard
        v-for="applicant in applicants"
        :key="applicant.id"
        :applicant="applicant"
        :targetJob="targetJob"
        :requestorId="requestorId"
        @click:detail="handleClickDetail"
        @click:ignoreApplicant="handleIgnoreApplicant"
    />
  </FlexColumn>
</template>

<script>
import FlexColumn from "@/components/atoms/FlexColumn";
import ApplicantCard from "@/components/organisms/ApplicantCard";
import {mapGetters} from "vuex";
export default {
  name: "ApplicantCards",
  components: {ApplicantCard, FlexColumn},
  props: {
    requestorId: {
      type: String
    },
  },
  data() {
    return {
      page: 1
    }
  },
  computed: {
    ...mapGetters('chatRequests', ['applicants', "applicantCount", "jobs"]),
    jobId() {
      return this.$route.params.id
    },
    targetJob() {
      return this.jobs.find(job => job.id === this.jobId)
    }
  },
  methods: {
    handleClickDetail(applicant) {
      this.$emit("click:detail", applicant)
    },
    handleIgnoreApplicant(applicant) {
      this.$emit("click:ignoreApplicant", applicant)
    }
  }
}
</script>

<style scoped>

</style>
